import React, {useState, useEffect} from 'react';
import {useRecoilValue} from 'recoil';
import {userState} from '../../../../recoil/user/userAtom';
import {useHistory} from 'react-router-dom';
import {ItemsContractor} from './ItemsContractor';
import {ItemsHomeowner} from './ItemsHomeowner';
import {
  getSelectedIndexFromCurrentUrl,
  NavigationPath,
} from '../SelectedIndexUtil';
import {isContractor, isHomeowner, isRealtor} from '../../../../util/UserUtils';
import Box from '@mui/material/Box';

interface IProps {
  width: number;
}

export const BarMenu: React.FC<IProps> = (props) => {
  const user = useRecoilValue(userState);
  const history = useHistory();

  const [selectedIndex, setSelectedIndex] = useState(NavigationPath.DEFAULT);

  useEffect(() => {
    setSelectedIndex(getSelectedIndexFromCurrentUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const handleListItemClick = (navigationPath: NavigationPath) => {
    history.push(`${navigationPath}`);
    setSelectedIndex(getSelectedIndexFromCurrentUrl());
  };

  const getMenuItems = () => {
    if (isHomeowner(user) || isRealtor(user)) {
      return (
        <ItemsHomeowner
          selectedIndex={selectedIndex}
          handleListItemClick={handleListItemClick}
        />
      );
    } else if (isContractor(user)) {
      return (
        <ItemsContractor
          selectedIndex={selectedIndex}
          handleListItemClick={handleListItemClick}
        />
      );
    }
  };

  return <>{props.width > 600 && <Box mr={2}>{getMenuItems()}</Box>}</>;
};
